/**
 * API 接口定義
 * 包含產出相關的數據獲取方法
 * 
 * 日誌查看方式：
 * 1. 打開瀏覽器開發者工具 (F12)
 * 2. 切換到 Console 頁籤
 * 3. 可以看到以下格式的日誌：
 *    - <DEBUG>[API Request]: API 請求信息
 *    - <DEBUG>[API Response]: API 響應數據
 */

import https from '@/apis/https'
import tools from '@/sag-core/tools'
import store from '@/store'

let apiKan = null

apiKan = class ApiKan {
    constructor() {
    }

    apiGetMFGOutput(data) {
        tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGOutput',
            data: data
        }})

        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGOutput',
            method: 'post',
            data: {
                StartDate: data.StartDate,
                EndDate: data.EndDate,
                ConfigID: data.ConfigID
            }
        })
    }

    apiGetEQPerformance(data) {
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGEQPerformanceMachine',
            method: 'post',
            data: {
                StartDate: data.StartDate,
                EndDate: data.EndDate,
                ConfigID: data.ConfigID
            }
        })
    }

    apiGetMFGYield(data) {
        tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGYield',
            data: data
        }})

        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGYield',
            method: 'post',
            data: {
                StartDate: data.StartDate,
                EndDate: data.EndDate,
                ConfigID: data.ConfigID
            }
        })
    }

    apiGetMFGTabletCalculate(data) {
        tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGTabletCalculate',
            data: data
        }})

        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/MFG/MFGTabletCalculate',
            method: 'post',
            data: {
                StartDate: data.StartDate,
                EndDate: data.EndDate
            }
        })
    }
}

// 測試環境 API
if(store.state.webConfig.apiTest) {
    apiKan = class TestApiKan {
        constructor() {
        }

        apiGetMFGOutput(data) {
            tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
                url: 'http://localhost:12345/MFG/MFGOutput',
                data: data
            }})

            return https({
                url: 'http://localhost:12345/MFG/MFGOutput',
                method: 'post',
                data: {
                    StartDate: data.StartDate,
                    EndDate: data.EndDate,
                    ConfigID: data.ConfigID
                }
            })
        }

        apiGetEQPerformance(data) {
            return https({
                url: 'http://localhost:12345/MFG/MFGEQPerformanceMachine',
                method: 'post',
                data: {
                    StartDate: data.StartDate,
                    EndDate: data.EndDate,
                    ConfigID: data.ConfigID
                }
            })
        }

        apiGetMFGYield(data) {
            tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
                url: 'http://localhost:12345/MFG/MFGYield',
                data: data
            }})

            return https({
                url: 'http://localhost:12345/MFG/MFGYield',
                method: 'post',
                data: {
                    StartDate: data.StartDate,
                    EndDate: data.EndDate,
                    ConfigID: data.ConfigID
                }
            })
        }

        apiGetMFGTabletCalculate(data) {
            tools.debug.log({tag: 'DEBUG', title: 'API Request', content: {
                url: 'http://localhost:12345/MFG/MFGTabletCalculate',
                data: data
            }})

            return https({
                url: 'http://localhost:12345/MFG/MFGTabletCalculate',
                method: 'post',
                data: {
                    StartDate: data.StartDate,
                    EndDate: data.EndDate
                }
            })
        }
    }
}

export default apiKan
